<ng-container *ngIf="currentUser?.idVerified || currentUser?.totpEnabled">
    <div class="header-helper">Two-factor authentication</div>
    <div class="content content-with-elevation">
        <ng-container *ngIf="!currentUser?.totpEnabled">
            <p>Scan the QR code below using the Authenticator App of your choice and provide the 6-digit confirmation
                code generated by the app.</p>
            <p>RZMS supports any authenticator app that uses the TOTP (Time-based One-Time Password) standard, including
                authenticator apps from Microsoft, Apple, and Google.</p>
            <div class="grid-x  align-end" *ngIf="!qrdata">
                <button class="iana-button" (click)="setup()">
                    Setup 2FA
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="currentUser?.totpEnabled">
            <button class="iana-button float-right" (click)="confirmDisable()">
                Disable 2FA
            </button>
            <p>Two-factor authentication is enabled for your account.</p>
            <p>Account recovery codes can be used as a second factor to authenticate if you lose access to your device.</p>
            <ng-container *ngIf="showRecoveryCodes">
                <div class="success-message grid-x recovery-code-success">
                    <fa-icon [icon]="'info-circle'"></fa-icon>
                    <div>
                        <h5 class="bold-text">Keep your recovery codes in a safe place</h5>
                        <p>If you lose your device and don't have the recovery codes, you will lose access to your account.</p>
                    </div>
                </div>
                <div class="recovery-codes-container">
                    <div class="card" id="recovery-codes">
                        <ul>
                            <li *ngFor="let code of recoveryCodes">{{code}}</li>
                        </ul>
                    </div>
                    <div class="grid-x grid-padding-1">
                        <button class="iana-button" (click)="downloadRecoveryCodes()">Download</button>
                        <button class="iana-button" (click)="printRecoveryCodes()">Print</button>
                        <button class="iana-button" (click)="copyCodesToClipboard()">Copy</button>
                    </div>
                </div>
                <div class="grid-x align-right">
                    <button class="iana-button" (click)="showRecoveryCodes = false">I have saved my codes</button>
                </div>
            </ng-container>
            <ng-container *ngIf="!showRecoveryCodes">
                <div class="grid-x align-right">
                    <button class="iana-button" (click)="confirmGenerateNewRecoveryCodes()">Generate New Codes</button>
                </div>
            </ng-container>
        </ng-container>

        <common-alerts [successMessage]="successMessage"></common-alerts>
        <common-alerts [errorMessage]="errorMessage"></common-alerts>
        <ng-container *ngIf="qrdata">
            <div class="qrcodeImage" *ngIf="qrdata">
                <qrcode
                        [qrdata]="qrdata"
                        [allowEmptyString]="true"
                        [ariaLabel]="'QR Code image with the following content...'"
                        [cssClass]="'center'"
                        [colorDark]="'#000000ff'"
                        [colorLight]="'#ffffffff'"
                        [elementType]="'canvas'"
                        [errorCorrectionLevel]="'M'"
                        [imageHeight]="75"
                        [imageWidth]="75"
                        [margin]="4"
                        [scale]="1"
                        [width]="300"
                ></qrcode>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="cell large-4 medium-6 small-12">
                    <label>Verify the code below to complete setup:
                        <input formControlName="code" type="text"
                               class="input-group-custom" required maxlength="6">
                    </label>
                </div>
                <div class="grid-x  align-end">
                    <div class="save-cancel-button-group">
                        <button class="iana-button" type="submit"
                                [disabled]="!form.valid">Save
                        </button>
                        <button class="iana-button-cancel" type="reset" (click)="cancel()">Cancel</button>
                    </div>
                </div>
            </form>

        </ng-container>
    </div>

    <common-smart-modal [dynamicID]="twoFactorModelRandomID"
                        [content]="modalContent"
                        [closeButtonText]="'Cancel'"
                        [acceptButtonText]="'Disable'"
                        [contentHeader]="commentModalHeader"
                        (proceed)="disable2FA($event)"
                        [commentMode]="false">
    </common-smart-modal>

    <common-smart-modal [dynamicID]="generateRecoveryCodesRandomID"
                        [content]="modalContent"
                        [closeButtonText]="'Cancel'"
                        [acceptButtonText]="'Continue'"
                        [contentHeader]="commentModalHeader"
                        [commentMode]="false"
                        (proceed)="generateRecoveryCodes()">
    </common-smart-modal>

</ng-container>
